import {Injectable, Injector} from '@angular/core';
import {BaseResourceService} from '@sicapes/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {HttpHeaders} from "@angular/common/http";

export class IScpb {
    id?: number;

    static fromJson(jsonData: any): IScpb {
        return Object.assign(new IScpb(), jsonData);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ScpbService extends BaseResourceService<IScpb> {

    constructor(protected injector: Injector) {
        super('rest/inscricoes', injector, IScpb.fromJson);
    }

    public obterBolsas(identificadorRegistrado: string): Observable<any[]> {
        return this.http.get(this.apiPath + `/scpb-bolsas/${identificadorRegistrado}`)
            .pipe(map(this.jsonDataToResources.bind(this)),
            catchError(this.handleError)
        );
    }

    public obterPagamentos(identificadorRegistrado: string): Observable<any[]> {
        return this.http.get(this.apiPath + `/scpb-bolsas/pagamentos/${identificadorRegistrado}`)
            .pipe(map(this.jsonDataToResources.bind(this)),
                catchError(this.handleError)
            );
    }

    protected jsonDataToResources(jsonData: any): any[] {
        return jsonData;
    }
}
